<template>
	<div class="container">
		<div class="handle-box" v-if='isAdmin'>
			<el-input size="small" v-model="query.phone" clearable placeholder="请输入账号" class="handle-input mr10"
				style="width: 180px" ></el-input>
	
			<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
				@click="handleSearch">搜索</el-button>
		</div>
		<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
			max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" v-loading="loading"
			:header-cell-style="{ 'text-align': 'center' }" stripe>
			<el-table-column prop="taskName" label="任务类型" align="center"></el-table-column>
			<el-table-column prop="failReason" label="失败原因" align="center" show-overflow-tooltip></el-table-column>
			<el-table-column prop="status" label="状态" align="center" width="120">
				<template #default="scope">
					<el-tag v-if="scope.row.status == 'processing'" type="warning" size="small">处理中</el-tag>
					<el-tag v-if="scope.row.status == 'completed'" type="success" size="small">成功</el-tag>
					<el-tag v-if="scope.row.status == 'failed'" type="danger" size="small">失败</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="processedRecords" label="已处理数量" align="center" width="120"></el-table-column>
			<el-table-column prop="totalRecords" label="任务总数" align="center" width="120"></el-table-column>
			<el-table-column prop="progress" label="进度" align="center">
				<template #default="scope">
					<el-progress :percentage="scope.row.progress?.toFixed(2)"></el-progress>
				</template>
			</el-table-column>
			<el-table-column prop="startTime" label="操作时间" align="center" width="200"></el-table-column>
			<el-table-column label="操作" align="center" width="150">
				<template #default="scope">
					<a :href="scope.row.url" class="down m_r_10" download="任务中心.xlsx" :class="[theme3]">
						<i class="el-icon-download"></i>
						下载
					</a>
					<el-button type="text" size="mini" @click="getJsonData(scope.row.jsonData)" :class="[theme3]"
						v-if="scope.row.jsonData">查看</el-button>
					<!--
						<el-button type="danger" size="mini" icon="el-icon-delete"
							@click="getDelete(scope.row.taskId)">清空任务</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination">
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="query.pageIndex"
				:page-sizes="[10, 20, 50, 100]" :page-size="query.pageSize" :total="pageTotal"
				@size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
		</div>
		<el-dialog v-model="filterBox" width="450px">
			<div class="filter-box">
				<div>
					<i class="el-icon-success" style="color: #40FF63;margin-right: 10px;"></i>
					导入成功：{{ filterListData.success || 0 }}条
				</div>
				<div v-if="filterListData.format > 0" @click="seeError" class="icon-class">
					<i class="el-icon-error" style="color: #FFB640;margin-right: 10px;"></i>
					格式错误：
					{{ filterListData.format }}
					条
				</div>
				<div v-else>
					<i class="el-icon-error" style="color: #FFB640;margin-right: 10px;"></i>
					格式错误：0 条
				</div>
				<div v-if="filterListData.repeats > 0" @click="seeFilesRepeating" class="icon-class">
					<i class="el-icon-warning" style="color: #FF6D40;margin-right: 10px;"></i>
					数据重复：
					{{ filterListData.repeats }}
					条
				</div>
				<div v-else>
					<i class="el-icon-warning" style="color: #FF6D40;margin-right: 10px;"></i>
					数据重复：{{ 0 }}条
				</div>
				<div v-if="filterListData.filter > 0" @click="seeEnterpriseDuplication" class="icon-class">
					<i class="el-icon-info" style="color: #FF40D6;margin-right: 10px;"></i>
					已过滤：
					{{ filterListData.filter }}
					条
				</div>
				<div v-else>
					<i class="el-icon-info" style="color: #FF40D6;margin-right: 10px;"></i>
					已过滤：{{ 0 }}条
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex.js';
	import {
		fetchDepartment
	} from '../api/index.js';
	import {
		fetchAgent
	} from '../api/agentIndex.js';
	import {
		querySubAgent
	} from '../api/serialIndex.js';
	import {
		getTask
	} from '../api/groupcall.js';
	export default {
		name: 'taskDesk',
		data() {
			return {
				query: {
					phone: '',
					pageIndex: 1,
					pageSize: 10,
				},
				tableData: [],
				pageTotal: 0,
				loading: false,
				
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				isAdmin: false,
				isSubAgent: false,
				isNormal: false,
				role: '',
				subAgent: '',
				middlePhoneList: [],
				filterBox: false,
				filterListData: [],
			};
		},
		created() {
			this.updatePaginationStyle();
			this.role = localStorage.getItem('ms_role');
			this.subAgent = localStorage.getItem('subAgent');
			this.init();
			this.getData();
			if (this.role === 'agent') {
				this.isNotAdmin = false;
				this.isAgent = true;
				this.isNormal = true;
				if (this.subAgent == 'true') {
					this.isSubAgent = true;
					this.getquerySubAgent();
				} else {
					this.isSubAgent = false;
				}
			}
			if (this.role === 'subAgent') {
				this.isAgent = true;
			}
			if (this.role === 'admin') {
				this.isAdmin = true;
				this.isAgent = true;
				this.isNormal = true;
			}

		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			handleSearch() {
				this.query.pageIndex = 1;
				this.getData()
			},


			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				if (this.subAgent == true) {
					this.isSubAgent = true;
					this.getquerySubAgent();
				}
				this.getfetchDefaultCompanies();
			},
			//子代理
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId,
				};
				fetchDefaultCompanies(data).then(res => {
					if (this.role == 'company' || this.role == 'department') {
						let data = {
							companyId: '',
							currentUserId: localStorage.getItem('user')
						};
						fetchDepartment(data).then(res => {
							this.departments = res.data;
							this.departmentList = res.data;
							this.query.companyId = res.data[0].value;
						});
					} else {
						this.companys = res.data;
					}
				});
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				this.query.departmentId = '';
				this.query.userId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			companyChange(companyId) {
				this.query.companyId = companyId;
				this.query.departmentId = '';
				this.query.userId = '';
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
					this.departmentList = res.data;
					this.query.pageIndex = 1;
				});
			},
			getData() {
				let data = {
					pageIndex: this.query.pageIndex,
					pageSize: this.query.pageSize,
					phone: this.query.phone,
				}
				getTask(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.pageIndex = 1; // 重置到第一页
				this.query.pageSize = val;
				this.getData();
			},

			getJsonData(item) {
				this.filterBox = true;
				this.filterListData = JSON.parse(item);
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.fixed-width-group .el-checkbox {
		width: 150px;
		margin-right: 0;
		/* 设置固定宽度 */
	}

	.filter-box div {
		display: flex;
		flex-direction: row;
		align-items: center;
		line-height: 50px;
		height: 50px;
		font-size: 16px;
	}

	.filter-box div i {
		font-size: 18px;
	}
</style>